export var SearchHeaderPlugin = function SearchHeaderPlugin() {
  return '';
};